import { LOCALE_ID, NgModule } from '@angular/core';
import localeNl from '@angular/common/locales/nl';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RegisterComponent } from './pages/register/register.component';
import { LoginComponent } from './pages/login/login.component';
import { ReserveComponent } from './pages/reserve/reserve.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { provideFirebase } from './firebase.providers';
import {
  AsyncPipe,
  DatePipe,
  NgClass,
  NgForOf,
  NgIf,
  NgSwitch,
  NgSwitchCase,
  registerLocaleData,
  TitleCasePipe,
} from '@angular/common';
import { ConfirmComponent } from './pages/confirm/confirm.component';
import { DatePickerComponent } from './shared/date-picker/date-picker.component';
import { TimePickerComponent } from './shared/time-picker/time-picker.component';
import { ClassListComponent } from './shared/class-list-admin/class-list.component';
import { MyReservationsComponent } from './pages/my-reservations/my-reservations.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { ClassDetailComponent } from './pages/classdetail/class-detail.component';
import { PrivacybeleidComponent } from './pages/privacybeleid/privacybeleid.component';
import { TrialUpgradeComponent } from './shared/trial-upgrade/trial-upgrade.component';
import { MyDataComponent } from './pages/my-data/my-data.component';
import { RouterLink, RouterOutlet, TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './seo/app-title.strategy';
import { ShellComponent } from './layout/shell.component';
import { BrowserModule } from '@angular/platform-browser';
import {
  AlertComponent,
  CalendarComponent,
  BadgeComponent,
  ButtonDirective,
  CardComponent,
  CheckboxDirective,
  FieldComponent,
  IconComponent,
  InputDirective,
  SpinnerComponent,
} from './ui';

registerLocaleData(localeNl, 'nl-BE');

@NgModule({
  declarations: [
    AppComponent,
    ReserveComponent,
    LoginComponent,
    RegisterComponent,
    ConfirmComponent,
    MyReservationsComponent,
    PasswordResetComponent,
    PrivacybeleidComponent,
    MyDataComponent,
  ],
  imports: [
    DatePickerComponent,
    TimePickerComponent,
    ClassListComponent,
    ClassDetailComponent,
    TrialUpgradeComponent,
    RouterLink,
    RouterOutlet,
    BrowserModule,
    ShellComponent,
    AlertComponent,
    BadgeComponent,
    CalendarComponent,
    ButtonDirective,
    CardComponent,
    CheckboxDirective,
    FieldComponent,
    IconComponent,
    InputDirective,
    SpinnerComponent,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    AsyncPipe,
    DatePipe,
    TitleCasePipe,
  ],
  providers: [
    provideFirebase(),
    DatePipe,
    {
      provide: LOCALE_ID,
      useValue: 'nl-BE',
    },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
